/**
 * useCreditsLabel — Phase C single source of truth for the in-app currency
 * label. Returns "Pro Credits" for adult-mode sessions, "Hearts" otherwise.
 * Plus helpers to format common transaction strings.
 *
 * Import everywhere a toast/modal/receipt currently hard-codes "Hearts".
 */
import useAdultMode from './useAdultMode';

export const useCreditsLabel = () => {
  const isAdultMode = useAdultMode();
  const label = isAdultMode ? 'Pro Credits' : 'Hearts';
  const single = isAdultMode ? 'Pro Credit' : 'Heart';

  const format = (n, opts = {}) => {
    const amount = Number(n ?? 0);
    const noun = amount === 1 ? single : label;
    if (opts.withVerb === 'spent')  return `You spent ${amount} ${noun}`;
    if (opts.withVerb === 'earned') return `You earned ${amount} ${noun}`;
    if (opts.withVerb === 'confirm')return `Confirm purchase of ${amount} ${noun}`;
    return `${amount} ${noun}`;
  };

  return { label, single, format, isAdultMode };
};

export default useCreditsLabel;
